import { symmetricDifference } from 'ramda';

export const hasValueChanged = (value: any, prevValue: any) => {
  if (Array.isArray(value) && Array.isArray(prevValue)) {
    if (value.length !== prevValue.length) {
      return true;
    } else {
      if (symmetricDifference(value, prevValue).length > 0) {
        return true;
      }
    }
  }

  if ((Array.isArray(value) && !Array.isArray(prevValue)) || (!Array.isArray(value) && Array.isArray(prevValue))) {
    return true;
  }

  return value !== prevValue;
};

export const defineValueToSend = (value: any, defaultValue: any) => {
  let outValue;

  try {
    if (!value) {
      if (defaultValue) {
        return Array.isArray(defaultValue) ? defaultValue : defaultValue.split(',');
      }

      return [];
    }

    if (Array.isArray(value)) {
      if (value.length < 1 && defaultValue) {
        return Array.isArray(defaultValue) ? defaultValue : defaultValue.split(',');
      } else {
        return value;
      }
    }
    outValue = value?.value ? [value.value] : value.split(',');
  } catch (err) {
    console.log(err);
  }


  return outValue;
};

export const getValue = (value: any, repeating: boolean) => {
  if (!value) return null;

  if (repeating) {
    if (!Array.isArray(value)) {
      return null;
    }

    return value.filter(item => Boolean(item.label));
  }

  return value;
};
